import type { ClientMedication } from '@shared/modules/client-medication/client-medication';
import { Presenter } from '@shared/presenters/presenter';
import { DateTime } from 'luxon';

export class ClientMedicationPresenter extends Presenter<ClientMedication> {

    get name() {
        return this._data.name;
    }

    get sideEffects() {
        return this._data.side_effects;
    }

    get dosageSummary() {
        return this._data.dosage;
    }

    get startDateTime() {
        return this.toDateTime('start', false);
    }

    get finishDateTime() {
        return this.toDateTime('finish', false);
    }

    get dates() {
        return this._get('dates', () => {
            const start = this.startDateTime;
            const finish = this.finishDateTime;

            if (start && finish) {
                return `${this.formatDate(start)} - ${this.formatDate(finish)}`;
            }

            if (start) {
                return `from ${this.formatDate(start)}`;
            }

            if (finish) {
                return `until ${this.formatDate(finish)}`;
            }
        });
    }

    get start() {
        return this._get('start', () => this.formatDateReadable(this.startDateTime));
    }

    get finish() {
        return this._get('finish', () => this.formatDateReadable(this.finishDateTime));
    }

    get isActive() {
        return this._get('isActive', () => {
            const nowDateTime = DateTime.local();
            const finishDateTime = this.finishDateTime;

            if (finishDateTime) {
                return finishDateTime > nowDateTime;
            }

            const startDateTime = this.startDateTime;

            if (startDateTime) {
                return startDateTime < nowDateTime;
            }
            return !startDateTime;
        });
    }

}
